import { Injectable } from '@angular/core';
import { MdSnackBar } from '@angular/material';

@Injectable()
export class NotificationService {

  constructor(private snackBar: MdSnackBar) {
  }

  show(msg: string) {
    this.snackBar.open(msg);
  }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/shared/services/notification.service.ts